import React, { useEffect, useRef, useState } from "react";
import { AutoComplete } from "@progress/kendo-react-dropdowns";
import { useLocalization } from "@progress/kendo-react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Message } from "@localization";
import Loading from "../loading";
import styled, { css } from "styled-components";
import { FlexCenter } from 'app-styled/flex';

const CustomNoDataMessageWrapper = styled(FlexCenter)`
  ${({ theme }) => css`
    margin: ${theme["margin-elementSmall"]}
  `}
`;

const DentistListSearch = ({
  getDentist,
  defaultDentist,
  dentistList,
  getDentistList,
  onClose,
  loading
}) => {
  const localization = useLocalization();
  const dispatch = useDispatch();
  const [value, setValue] = useState(defaultDentist);

  let dentsitFoundRef: any = useRef()
  let timer = null;
  
  useEffect(() => {
    value && dispatch(getDentistList(value));
  }, []);

  useEffect(() => {
    const selectedDentist = dentistList.find((dentist) => dentist.Practice == value);
    if(selectedDentist){
      dentsitFoundRef.current = true
      getDentist(selectedDentist.Id);
    }else{
      dentsitFoundRef.current = false;
      getDentist(null);
    }
  }, [JSON.stringify(dentistList), value]);

  const onTextChange = (value: string) => {
    timer && clearTimeout(timer);
    timer = setTimeout(() => {
      return (value && !dentsitFoundRef.current) && dispatch(getDentistList(value));
    }, 1000);
  };

  const onChange = (event) => {

    setValue(event.value);
    onTextChange(event.value);
  };


  const customNoDataMessage = () => (
    <CustomNoDataMessageWrapper> {loading ?
      <Loading /> :
      <Message messageKey={"no_dentist_found"} defaultMessage={"No Dentist found.!"} />
    }
    </CustomNoDataMessageWrapper>
  );
  return (
    <div className="example-wrapper">
      <AutoComplete
        data={dentistList}
        textField={"Practice"}
        value={value}
        onChange={onChange}
        onClose={onClose}
        placeholder={`${localization.toLanguageString(
          "dentist_search",
          "Dentist Search"
        )} ...`}
        listNoDataRender={customNoDataMessage}
      />
    </div>
  );
};

export default DentistListSearch;
